import { isVaultUnlocked, keychainManager } from '@plug-core/keyring'
import { useUserActivity } from '@plug-core/state'

const LOCK_TIMEOUT = 3600

export const setLockInterval = () => {
  setInterval(async () => {
    const { lastUserActivityAt } = useUserActivity.getState()

    if (!lastUserActivityAt || !isVaultUnlocked()) return

    if (new Date().getTime() - Date.parse(lastUserActivityAt) > LOCK_TIMEOUT * 1000) {
      keychainManager.lock()
    }
  }, 1000)
}
